import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';

// Import components
import { Alert } from 'components/elements';

// Import styled Components
import { FormWrapper, Title } from './styles';

// Import helpers
import { handleFormChange } from 'helpers/form';

// Import hooks
import { useModalForm } from './useModalForm';

const ModalForm = ({
	children,
	closeModal,
	submitAction,
	isError,
	translation,
	isOpen,
	validation,
	initialValues,
	isEnabled,
	errorMessage,
	title,
	titleId = null
}) => {
	const { t } = useTranslation();
	// Create form ref
	const form = React.useRef();

	const { handleModalFormSubmit } = useModalForm({
		form,
		closeModal,
		submitAction,
		isEnabled,
		validation,
		isOpen,
		isError
	});

	return (
		<FormWrapper>
			<Title id={titleId}>{title}</Title>
			<Formik
				ref={form}
				initialValues={initialValues}
				validateOnChange={false}
				validateOnBlur={false}
				onSubmit={handleModalFormSubmit}
			>
				{({ handleSubmit, handleChange, setErrors, isSubmitting }) => (
					<form
						data-testid="login-form"
						onSubmit={handleSubmit}
						onChange={handleFormChange({ handleChange, setErrors })}
					>
						{isError && (
							<Alert
								closeBtn={false}
								testid="static-error"
								text={errorMessage || t(`${translation}`)}
							/>
						)}

						{children({ isSubmitting })}
					</form>
				)}
			</Formik>
		</FormWrapper>
	);
};

ModalForm.propTypes = {
	closeModal: PropTypes.func.isRequired,
	submitAction: PropTypes.func.isRequired,
	isError: PropTypes.bool.isRequired,
	errorMessage: PropTypes.string,
	isEnabled: PropTypes.bool,
	isOpen: PropTypes.bool.isRequired,
	initialValues: PropTypes.object.isRequired,
	validation: PropTypes.func,
	translation: PropTypes.string.isRequired,
	children: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired,
	titleId: PropTypes.string
};

const mapStateToProps = (state, { type }) => {
	const { isError, errorMessage } = state[type];
	return {
		isError,
		errorMessage
	};
};

export default connect(mapStateToProps)(ModalForm);
